import { SVGProps } from 'react';

export const IconPerson = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <path
        d='M11.8246 13.2662C9.63014 13.2662 5.25 14.6216 5.25 17.3122V19.3351H18.3993V17.3122C18.3993 14.6216 14.0191 13.2662 11.8246 13.2662Z'
        fill='currentColor'
      />
      <path
        d='M11.8246 11.9175C13.8729 11.9175 15.5334 10.2571 15.5334 8.20876C15.5334 6.16047 13.8729 4.5 11.8246 4.5C9.77632 4.5 8.11584 6.16047 8.11584 8.20876C8.11584 10.2571 9.77632 11.9175 11.8246 11.9175Z'
        fill='currentColor'
      />
    </svg>
  );
};
